import { NexameroMark } from "@rakazo/ui-web";
import type { ReactNode } from "react";
import { desktopBridge } from "../../lib/desktop";
import { WindowChrome } from "../WindowChrome";

/**
 * Spans the app above the floating sidebar, chat and side panel: mark and Space tabs at the
 * start, account controls at the end. The bar itself drags the desktop window.
 */
export function ShellTopBar({ spaceTabs, account }: { spaceTabs: ReactNode; account: ReactNode }) {
  return (
    <header
      data-testid="shell-top-bar"
      className="app-drag flex h-14 shrink-0 items-center gap-3 px-3"
    >
      {desktopBridge() ? <WindowChrome /> : null}
      <span
        aria-hidden="true"
        className="grid size-8 shrink-0 place-items-center rounded-[10px] bg-primary text-primary-foreground shadow-panel"
      >
        <NexameroMark className="size-5" />
      </span>
      <div className="app-no-drag flex min-w-0">{spaceTabs}</div>
      <div className="app-no-drag ms-auto flex shrink-0 items-center">{account}</div>
    </header>
  );
}
